import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-common-subproducts-whitepaper',
  templateUrl: './white-paper.component.html',
  styleUrls: ['./white-paper.component.scss'],
  imports: [CommonModule, ToHtmlPipe, UrlParamsPipe],
  encapsulation: ViewEncapsulation.None,
})
export class CommonSubProductsWhitePaperComponent implements OnInit {
  @Input() whitePaperData: any;
  @Input() customClass: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute,
    private posthog: PosthogService
  ) {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }
  _whitePaperData: any;
  path: string = 'About-Us/Resources/Whitepapers-and-Reports/'.toLocaleLowerCase();
  ngOnInit(): void {
    this._whitePaperData = this.whitePaperData;
  }
  ngOnChanges(): void {
    this._whitePaperData = this.whitePaperData;
  }

  onWhitepaperCTAClick(): void {
    this.posthog.captureContentClick('whitepaper', {
      contentTitle: this._whitePaperData?.title,
      location: 'product_page',
      destinationUrl: `${this.path}${this._whitePaperData?.blogId}`
    });
  }
}
